import { Progress } from "antd";
import { FaCircleCheck } from "react-icons/fa6";
import { IoIosCloseCircle } from "react-icons/io";
import { formatDate } from "../utils/functions";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setCompleteInfo } from "../context/accountSlice";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ProgressCard({ account }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const correct = <FaCircleCheck color="green" size={16} />;
  const wrong = <IoIosCloseCircle color="red" size={20} />;

  // Check how many counts exceed 0
  const completedTasks = [
    account?.businessesCount,
    account?.outletsCount,
    account?.rewardsCount,
    account?.stampcardsCount,
  ].filter((count) => count > 0).length;

  const totalTasks = 4;
  const progressPercentage = (completedTasks / totalTasks) * 100;

  // // Dispatch global completeInfo
  // useEffect(() => {
  //   const isComplete = completedTasks === totalTasks;
  //   dispatch(setCompleteInfo(isComplete));
  // }, [completedTasks, dispatch]);

  return (
    <div className="progress-card">
      <div className="progress-card-header">
        <Progress
          strokeColor="#f11e69"
          type="circle"
          percent={progressPercentage}
          size={60}
          strokeWidth={10}
        />
        <div>
          <h5>{t("completeInformation")}</h5>
          <p>{t("completeInfoSubtitle")}</p>
        </div>
      </div>

      <h6 className="subtitle active">{t("actions")}</h6>
      <ul>
        <li>
          <div>
            <h5>{t("signUp")}</h5>
            <h6>
              {account?.account?.created &&
                formatDate(account?.account?.created)}
            </h6>
          </div>
          <FaCircleCheck color="green" size={16} />
        </li>
        <li>
          <h5>{t("completeBusinessInfo")}</h5>
          {account?.businessesCount > 0 ? correct : wrong}
        </li>
        <li>
          <Link to="/outlets">
            <h5>{t("addOutlet")}</h5>
            {account?.outletsCount > 0 ? correct : wrong}
          </Link>
        </li>
        <li>
          <Link to="/rewards">
            <h5>{t("rewards")}</h5>
            {account?.rewardsCount > 0 ? correct : wrong}
          </Link>
        </li>
        <li>
          <Link to="/stamp-card">
            <h5>{t("createStamp")}</h5>
            {account?.stampcardsCount > 0 ? correct : wrong}
          </Link>
        </li>
      </ul>
    </div>
  );
}
